import React, { useState, useEffect } from 'react';
import Blog from '../components/Blog/Blog'; // Переименуйте импортируемый компонент
import Faq from '../components/Main/Faq'
import Footer from '../components/Main/Footer'
import { BACKEND_URL } from '../consts';

const BlogPage = () => {
  const [data, setData] = useState([]); // Инициализация как пустой массив
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${BACKEND_URL}/api/v1/block/blog`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const fetchedData = await response.json();
        
        // Логируем данные для проверки
        console.log(fetchedData);

        // Проверяем, является ли fetchedData массивом
        if (Array.isArray(fetchedData)) {
          setData(fetchedData);
        } else {
          throw new Error('Fetched data is not an array');
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      {data.map((block, index) => {
        if (block.type === "blog_block") { // Измените условие на правильный тип блока
          return <Blog data={block.payload} />; // Передайте нужные данные в компонент
        }
        if (block.type === "faq_block"){
          return <Faq data={block.payload}/>
        }
        if (block.type === "footer_block"){
          return <Footer data={block.payload}/>
        }
        return null; // Возвращаем null для других типов блоков
      })}
    </>
  );
};

export default BlogPage;
